export default __webpack_public_path__ + "static/media/jaggedcut2.7fa36e14.png";